import { render } from "./etImgView.vue?vue&type=template&id=4653a2fe"
import script from "./etImgView.vue?vue&type=script&lang=js"
export * from "./etImgView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__